import { render, staticRenderFns } from "./ProductFormVariantPerishability.vue?vue&type=template&id=75d58d7a&"
import script from "./ProductFormVariantPerishability.vue?vue&type=script&lang=js&"
export * from "./ProductFormVariantPerishability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports